<template>
    <div class="mt-0" :style="isMobile ? 'padding: 15px' : ''">
        <ion-grid v-if="!errorMsg && storeLocation" class="ion-no-padding location-info" :data-cy="'location-' + storeLocation.slug" :id="'location-' + storeLocation.slug">
            <!-- Store is open and can deliver to the provided address. -->
            <ion-row v-if="isDeliveryTurnedOn && isStoreOpen" data-cy="delivery-info" class="delivery-info ion-justify-content-center">
                <ion-col size="12" class="px-16">
                    <storeStatus :storeLocation="storeLocation" />
                    <h5 class="ion-no-margin color-black estimated-title"><strong>Estimated Arrival Time:</strong></h5>
                    <h2 class="ion-no-margin py-8 bold x-large" v-if="storeLocation.storeStatus">
                        <ion-text color="primary" data-cy="location-delivery-delay">
                            {{ storeLocation.storeStatus.deliverydelay }} - {{ storeLocation.storeStatus.deliverydelay + 5 }} minutes
                        </ion-text>
                    </h2>
                    <h5 v-if="storeLocation?.name" data-cy="location-name" class="ion-no-margin pb-8 bold location-name" style="font-size: 1.5em">From {{ storeLocation.name }}</h5>

                    <storeTime v-if="storeLocation" :storeLocation="storeLocation" showTodayHours class="d-inline color-dark bold" style="font-size: 1.2em" />
                </ion-col>
            </ion-row>

            <!-- If location has Delivery Turned off (doesn't matter if the store is open or closed). -->
            <ion-row class="ion-justify-content-center" v-else-if="isDeliveryTurnedOff" data-cy="delivery-unavailable">
                <ion-col size="10" size-md="8">
                    <storeStatus :storeLocation="storeLocation" />
                    <h4 class="my-0 color-black bold">Delivery Unavailable</h4>
                    <h5 class="my-8">We currently cannot deliver to:</h5>
                    <addressDisplay :address="deliveryAddress" data-cy="delivery-address" dense showZip />
                    <h5>Try another address or order pickup</h5>

                    <ion-button expand="block" color="primary" @click="$emit('changePickup')">Order Pickup</ion-button>
                </ion-col>
            </ion-row>

            <!-- Store is not open but can deliver to the provided address -> order ahead. -->
            <ion-row class="ion-justify-content-center" v-else-if="isDeliveryTurnedOn && !isStoreOpen" data-cy="delivery-unavailable">
                <ion-col size="10" size-md="8">
                    <storeStatus :storeLocation="storeLocation" />
                    <h4 class="my-0 color-black bold">This Donatos is closed right now.</h4>
                    <h5 class="my-8">We currently cannot deliver to:</h5>
                    <addressDisplay :address="deliveryAddress" data-cy="delivery-address" dense showZip />
                    <h5>You can order ahead for a time when the restaurant is open.</h5>

                    <ion-button expand="block" color="primary" @click="$emit('deliverHere')">Order Ahead</ion-button>
                </ion-col>
            </ion-row>
        </ion-grid>

        <!-- errorMsg handler -->
        <ion-grid v-else-if="errorMsg" class="ion-no-padding location-info" data-cy="location-error-card">
            <ion-row class="ion-justify-content-center" data-cy="delivery-unavailable">
                <ion-col size="11" size-md="8">
                    <h4 class="my-0 color-black bold">Delivery Unavailable</h4>
                    <h5 class="my-8">We currently cannot deliver to:</h5>
                    <addressDisplay :address="deliveryAddress" data-cy="delivery-address" dense showZip />
                    <h5>Try another address or order pickup</h5>
                    <ion-button expand="block" color="primary" @click="$emit('changePickup')">Order Pickup</ion-button>
                </ion-col>
            </ion-row>
        </ion-grid>
    </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';
import { IonGrid, IonRow, IonCol, IonText, IonButton } from '@ionic/vue';
import addressDisplay from '@/components/addressDisplay.vue';
import storeTime from '@/components/storeTime.vue';
import storeStatus from '@/components/storeStatus.vue';
import { StoreLocation } from '@/models/locationModels';
import { Address } from '@/models/addressModels';

export default defineComponent({
    props: {
        storeLocation: {
            type: Object as PropType<StoreLocation>,
        },
        deliveryAddress: {
            type: Object as PropType<Address>,
        },
        errorMsg: String,
        isDeliveryTurnedOff: Boolean,
        isDeliveryTurnedOn: Boolean,
        isStoreOpen: Boolean,
        isMobile: Boolean,
    },
    components: { IonGrid, IonRow, IonCol, addressDisplay, storeTime, IonText, storeStatus, IonButton },
    emits: ['changePickup', 'deliverHere'],
});
</script>

<style scoped>
.estimated-title {
    font-size: 2rem;
}
.location-info {
    margin-top: 16px;
}
@media screen and (min-width: 960px) {
    .estimated-title {
        font-size: 2.3rem;
    }
    .location-info {
        margin-top: 40px;
        font-weight: bold;
    }
}
</style>
